// src/lib/auth.js
import { getAuth } from "firebase/auth";

export async function getIdToken() {
  const user = getAuth().currentUser;
  if (!user) return null;
  try {
    return await user.getIdToken(true); // force fresh token
  } catch {
    return null;
  }
}
